import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Owned by the report lib so FrontPageComponent can announce that its two
 * asynchronously-fetched images (logo, header) have settled — loaded or
 * failed — without reaching into a consuming application.
 *
 * FrontPageComponent's images are fetched via `fetch()` + `FileReader` in
 * `ngOnInit`, entirely independent of the chart-rendered wait
 * (`ChartRenderedService`) that a report capture already waits on. Before
 * this signal existed, ReportRenderService's off-screen capture had no
 * way to know whether these two images had resolved before it flipped
 * `download` and read `#document`'s innerHTML — a report captured before
 * they landed silently omitted both `<img>` elements (they are `*ngIf`-gated
 * on `logo`/`front_image` being set), producing a smaller, incomplete HTML
 * capture with no error of any kind (TK-080 AC3).
 */
@Injectable({
  providedIn: 'root',
})
export class ReportAssetsRenderedService {

  private readySource = new Subject<boolean>();

  ready$: Observable<boolean> = this.readySource.asObservable();

  ready(): void {
    this.readySource.next(true);
  }
}
